import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";
import { MemoryRouter } from "react-router-dom";
import { MapAPI } from "../Map";

//  CONTEXT
const MapContext = createContext({} as MapAPI);

/**it's empty for the moment */
export const MapProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("MapProvider render");

  //  API
  const api = useMemo(() => {
    return {};
  }, []);

  return (
    <MapContext.Provider value={api}>
      <MemoryRouter>{children}</MemoryRouter>
    </MapContext.Provider>
  );
};

//  CUSTOM HOOKS
export const useMapAPI = () => useContext(MapContext);
